import { createAsyncThunk } from "@reduxjs/toolkit";
import { restoreRightsizingRecommendationThunk } from "./rightsizing/dismiss/restoreRightsizingRecommendationThunk";
import { restoreDailyOffHoursRecommendationThunk } from "./off-hours/dismiss/restoreDailyOffHoursRecommendationThunk";
import { restoreWeeklyOffHoursRecommendationThunk } from "./off-hours/dismiss/restoreWeeklyOffHoursRecommendationThunk";
import { refetchDataAfterActionThunk } from "./refetchDataAfterActionThunk";
import { RootState } from "../../store";
import { selectedDismissedRecommendationIdsByTypesSelector } from "../selectors/selected-ids/selectedDismissedRecommendationIdsByTypesSelector";

export const recommendationRestoreThunk = createAsyncThunk(
  "recommendations/recommendationRestoreThunk",
  async (_: void, { dispatch, getState }) => {
    const state = getState() as RootState;

    const ids = selectedDismissedRecommendationIdsByTypesSelector(state);

    const computeDaly = ids.computeDaily;
    const computeWeekly = ids.computeWeekly;

    const dbDaily = ids.dbDaily;
    const dbWeekly = ids.dbWeekly;

    if (ids.rightsizing.length) {
      await dispatch(restoreRightsizingRecommendationThunk(ids.rightsizing));
    }

    if (computeDaly.length || dbDaily.length) {
      await dispatch(
        restoreDailyOffHoursRecommendationThunk([...computeDaly, ...dbDaily]),
      );
    }

    if (computeWeekly.length || dbWeekly.length) {
      await dispatch(
        restoreWeeklyOffHoursRecommendationThunk([
          ...computeWeekly,
          ...dbWeekly,
        ]),
      );
    }

    await dispatch(
      refetchDataAfterActionThunk({
        rightsizing: !!ids.rightsizing.length,
        computeDaly: !!computeDaly.length,
        computeWeekly: !!computeWeekly.length,
        dbWeekly: !!dbWeekly.length,
        dbDaily: !!dbDaily.length,
      }),
    );
  },
);
